import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSaveProjectEditorContentArgs,
  BackendProject,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SaveProjectEditorContent(
    $projectId: ID!
    $html: String!
    $anchors: [SavedDocumentAnchorUpdateInput!]
  ) {
    saveProjectEditorContent(projectId: $projectId, html: $html, anchors: $anchors) {
      id
      editorContent
    }
  }
`;

export type SaveProjectEditorContentVariables = BackendMutationSaveProjectEditorContentArgs;
type Result = Pick<BackendProject, 'id' | 'editorContent'>;

export const saveProjectEditorContent = async (variables: SaveProjectEditorContentVariables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
